/* eslint-disable react/prop-types */
import {Box, Divider} from '@mui/material';
import Grid from '@mui/material/Grid';

import SingleSecret from '../SingleSecret/SingleSecret';
import {groupBy} from '../utils';

const SecretsByConnector = ({secrets, connectors}) => {
  const grouped = groupBy(secrets, 'connector');

  return (
    <>
      {Object.entries(grouped).map(([connectorId, connectorSecrets]) => {
        const connector = connectors.find(c => c.id === connectorId);

        return (
          <Grid
            key={connectorId}
            container
            alignItems="center"
            gap={2}
            sx={{
              border: '1px solid lightgrey',
              borderRadius: 2,
              px: 3,
              py: 2,
              mt: 1.5
            }}
          >
            <Box component="img" src={connector?.url_logo} alt={connector?.name} sx={{maxHeight: 20}} />

            <Divider sx={{width: '100%'}} />

            {connectorSecrets.map(secret => (
              <SingleSecret key={secret.secret_name} secret={secret} />
            ))}
          </Grid>
        );
      })}
    </>
  );
};

export default SecretsByConnector;
